export default __webpack_public_path__ + "d2c764fa5bff91532170b0cca709f3df.svg";